import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../../util/varios";
import moment from "moment";
import axios from "axios";
import useTableR from "../../useTableR";
import { Dimmer } from "../../spinner";

const TablaMultaVehiculos = (props) => {
  const token = localStorage.getItem("jwtToken");
  const op = require("../../../modulos/datos");
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const headCells = [
    {
      id: "fechamulta",
      label: "FECHA",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "descripcion",
      label: "DESCRIPCIÓN",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "idcontribuyente",
      label: "CODIGO CONTRIBUYENTE",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "valor",
      label: "MULTA",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "cancelada",
      label: "ESTATUS",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableR(records, headCells, filterFn);
  const buscarRegistros = async (idVehiculo) => {
    try {
      setLoading(true);
      const campos = "*";
      const tabla = "multa";
      const nombreid = "idcontribuyente";
      const nombreid2 = "tablacontribuyente";
      const valorid2 = "vehiculo";
      const nombreid3 = "tipoimpuesto";
      const valorid3 = "IMPUESTOS DE VEHICULOS";
      const endpoint = `${op.conexion}/api/consulta/modeli3string?campos=${campos}&id=${idVehiculo}&nomtab=${tabla}&nomid=${nombreid}&nomid2=${nombreid2}&id2=${valorid2}&nomid3=${nombreid3}&id3=${valorid3}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.lenght > 0
      ) {
        setRecords(response.data);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar las Multas del Vehiculo",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (props && props.idVehiculo) {
      buscarRegistros(props.idVehiculo);
    }
  }, [props.idVehiculo]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer
                  container={{
                    height: 250,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                  }}
                >
                  <TblHead />

                  <tbody>
                    {records &&
                      recordsAfterPagingAndSorting().map((item, index) => (
                        <tr key={index} style={{ padding: "0" }}>
                          <td style={{ fontSize: "10px", textAlign: "center" }}>
                            {moment.utc(item.fechamulta).format("DD-MM-YYYY")}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "center" }}>
                            {item.descripcion}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "center" }}>
                            {item.idcontribuyente}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "right" }}>
                            {formatMoneda(
                              item.valor.toString().replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td style={{ fontSize: "10px", textAlign: "center" }}>
                            {item.cancelada === true ? "PAGADA" : "POR PAGAR"}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dimmer active={loading} inverted />
    </div>
  );
};
export default TablaMultaVehiculos;
